import { useGetListOrganization } from '@/hooks/index';

export function useOrganization() {
	const { isLoading, isFetching, data: organizations } = useGetListOrganization();

	function getOrganizationOptions(): Array<{ label: string; value: string }> {
		return organizations?.map(({ id, name }) => ({ label: name, value: id })) || [];
	}

	return {
		organizations,
		isFetching,
		isLoading,
		getOrganizationOptions
	};
}
